import { withChartLayout } from 'components/common';
import DrugScreen from 'components/features/chart/admission-history/drug-screen/DrugScreen';

const DrugScreenPage = withChartLayout('Drug Screen')(DrugScreen);
export default DrugScreenPage;
